<div class="setting-page">
  <legend>WebSocket Tunnel</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="!canSubmit">
    <div class="settings-section">
      <form #mapForm="ngForm" autocomplete="off">
        <p>
          <mat-slide-toggle [(ngModel)]="webSocketSettings.tunEnabled" color="primary" name="isTunEnabled">
            Enable WebSocket Tunnel IP
          </mat-slide-toggle>
        </p>
        <p>
          <mat-form-field class="halfWidth">
            <mat-label>Username</mat-label>
            <input type="text" [(ngModel)]="webSocketSettings.nginxUserName" matInput name="nginxusername"
                   [disabled]="!webSocketSettings.tunEnabled">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="halfWidth">
            <mat-label>Password</mat-label>
            <input type="password" [(ngModel)]="webSocketSettings.nginxPassword" matInput name="nginxpassword"
                   placeholder="*" [disabled]="!webSocketSettings.tunEnabled">
          </mat-form-field>
        </p>

      </form>

    </div>
  </arm-form>
</div>
